import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 2024</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Fitness Health Blog ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website topfitnessproducts.com and purchase our premium fitness and health products.
          </p>
          <p>
            By accessing or using our website, you agree to the terms of this Privacy Policy. If you do not agree with the terms of this policy, please do not access or use our services.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          
          <h3>2.1 Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Create an account on our website</li>
            <li>Make a purchase or place an order</li>
            <li>Subscribe to our newsletter</li>
            <li>Contact us via email, phone, or contact forms</li>
            <li>Participate in surveys, promotions, or contests</li>
            <li>Leave reviews or comments on our products</li>
          </ul>
          
          <p>This personal information may include:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Telephone number (+448648285526 for customer service)</li>
            <li>Shipping and billing address</li>
            <li>Payment information (processed securely through our payment processors)</li>
            <li>Date of birth (for age verification)</li>
            <li>Gender (optional, for product recommendations)</li>
            <li>Fitness goals and preferences</li>
          </ul>

          <h3>2.2 Automatically Collected Information</h3>
          <p>When you visit our website, we automatically collect certain information about your device and browsing behavior, including:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Device type (mobile, tablet, desktop)</li>
            <li>Pages viewed and time spent on pages</li>
            <li>Referring website or source</li>
            <li>Click patterns and navigation paths</li>
            <li>Geographic location (country and city level)</li>
          </ul>

          <h3>2.3 Cookies and Tracking Technologies</h3>
          <p>
            We use cookies, web beacons, pixel tags, and similar tracking technologies to collect information about your browsing activities. This helps us improve your user experience, analyze website traffic, and personalize content. You can control cookie preferences through your browser settings.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information for various purposes, including:</p>
          
          <h3>3.1 Order Processing and Fulfillment</h3>
          <ul>
            <li>Processing and completing your orders</li>
            <li>Shipping products to your designated address</li>
            <li>Sending order confirmations and updates</li>
            <li>Processing payments and preventing fraud</li>
            <li>Managing returns and refunds</li>
          </ul>

          <h3>3.2 Customer Service</h3>
          <ul>
            <li>Responding to your inquiries and support requests</li>
            <li>Providing product information and recommendations</li>
            <li>Resolving disputes and troubleshooting issues</li>
            <li>Conducting customer satisfaction surveys</li>
          </ul>

          <h3>3.3 Marketing and Communications</h3>
          <ul>
            <li>Sending promotional emails about new products, special offers, and fitness tips</li>
            <li>Personalizing your shopping experience</li>
            <li>Displaying targeted advertisements</li>
            <li>Managing loyalty programs and rewards</li>
          </ul>

          <h3>3.4 Website Improvement</h3>
          <ul>
            <li>Analyzing user behavior and preferences</li>
            <li>Improving website functionality and user experience</li>
            <li>Testing new features and products</li>
            <li>Conducting market research</li>
          </ul>

          <h3>3.5 Legal Compliance</h3>
          <ul>
            <li>Complying with legal obligations and regulations</li>
            <li>Enforcing our Terms and Conditions</li>
            <li>Protecting our rights and preventing fraud</li>
            <li>Responding to law enforcement requests</li>
          </ul>
        </section>

        <section>
          <h2>4. Information Sharing and Disclosure</h2>
          <p>We do not sell your personal information to third parties. However, we may share your information with:</p>

          <h3>4.1 Service Providers</h3>
          <p>We work with trusted third-party service providers who assist us in operating our business, including:</p>
          <ul>
            <li>Payment processors (for secure payment transactions)</li>
            <li>Shipping and logistics companies</li>
            <li>Email marketing platforms</li>
            <li>Cloud hosting providers</li>
            <li>Analytics services (Google Analytics)</li>
            <li>Customer support tools</li>
          </ul>

          <h3>4.2 Business Transfers</h3>
          <p>
            In the event of a merger, acquisition, reorganization, or sale of assets, your information may be transferred to the new entity. We will notify you of any such change and provide options regarding your personal information.
          </p>

          <h3>4.3 Legal Requirements</h3>
          <p>We may disclose your information when required by law or in response to:</p>
          <ul>
            <li>Court orders or legal processes</li>
            <li>Government or regulatory requests</li>
            <li>Protection of our legal rights</li>
            <li>Prevention of fraud or illegal activities</li>
            <li>Protection of safety and security</li>
          </ul>

          <h3>4.4 With Your Consent</h3>
          <p>
            We may share your information with third parties when you explicitly consent to such sharing, such as when participating in co-branded promotions or third-party integrations.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:
          </p>
          <ul>
            <li>SSL/TLS encryption for data transmission</li>
            <li>Secure payment processing through PCI-DSS compliant providers</li>
            <li>Regular security audits and vulnerability assessments</li>
            <li>Access controls and authentication requirements</li>
            <li>Employee training on data protection practices</li>
            <li>Regular data backups and disaster recovery procedures</li>
          </ul>
          <p>
            However, no method of transmission over the internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. Retention periods vary based on:
          </p>
          <ul>
            <li>Account activity and status</li>
            <li>Legal and regulatory requirements</li>
            <li>Business and operational needs</li>
            <li>Dispute resolution and legal claims</li>
          </ul>
          <p>
            When personal information is no longer needed, we will securely delete or anonymize it in accordance with our data retention policies.
          </p>
        </section>

        <section>
          <h2>7. Your Rights and Choices</h2>
          
          <h3>7.1 Access and Correction</h3>
          <p>
            You have the right to access, update, or correct your personal information. You can do this by logging into your account or contacting us at the address below.
          </p>

          <h3>7.2 Data Portability</h3>
          <p>
            You have the right to request a copy of your personal information in a structured, commonly used, and machine-readable format.
          </p>

          <h3>7.3 Deletion</h3>
          <p>
            You have the right to request deletion of your personal information, subject to certain legal exceptions (e.g., order records for tax purposes).
          </p>

          <h3>7.4 Marketing Opt-Out</h3>
          <p>
            You can unsubscribe from marketing emails by clicking the "unsubscribe" link in any promotional email or by updating your communication preferences in your account settings.
          </p>

          <h3>7.5 Cookie Preferences</h3>
          <p>
            You can manage cookie preferences through your browser settings or our cookie consent tool. Note that disabling cookies may affect website functionality.
          </p>

          <h3>7.6 Do Not Track</h3>
          <p>
            Some browsers support "Do Not Track" signals. Our website does not currently respond to these signals, but we provide options to control tracking through cookie settings.
          </p>
        </section>

        <section>
          <h2>8. Third-Party Links and Services</h2>
          <p>
            Our website may contain links to third-party websites, including social media platforms (Facebook, Instagram, Twitter), payment processors, and partner sites. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies before providing any personal information.
          </p>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us immediately, and we will take steps to delete such information.
          </p>
        </section>

        <section>
          <h2>10. International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries outside of your country of residence, including the United Kingdom and European Union. We ensure appropriate safeguards are in place to protect your information in accordance with applicable data protection laws, including:
          </p>
          <ul>
            <li>Standard Contractual Clauses approved by regulatory authorities</li>
            <li>Privacy Shield frameworks (where applicable)</li>
            <li>Adequacy decisions by relevant data protection authorities</li>
          </ul>
        </section>

        <section>
          <h2>11. California Privacy Rights</h2>
          <p>
            If you are a California resident, you have specific rights under the California Consumer Privacy Act (CCPA), including:
          </p>
          <ul>
            <li>Right to know what personal information is collected</li>
            <li>Right to know if personal information is sold or disclosed</li>
            <li>Right to opt-out of the sale of personal information</li>
            <li>Right to request deletion of personal information</li>
            <li>Right to non-discrimination for exercising privacy rights</li>
          </ul>
          <p>
            We do not sell personal information. To exercise your rights, please contact us using the information below.
          </p>
        </section>

        <section>
          <h2>12. GDPR Compliance (EU/UK Users)</h2>
          <p>
            If you are located in the European Union or United Kingdom, we process your personal information in accordance with the General Data Protection Regulation (GDPR) and UK GDPR. Our legal bases for processing include:
          </p>
          <ul>
            <li>Contract performance (processing orders and providing services)</li>
            <li>Consent (marketing communications and optional features)</li>
            <li>Legitimate interests (website improvement and fraud prevention)</li>
            <li>Legal compliance (tax and regulatory obligations)</li>
          </ul>
          <p>
            You have the right to lodge a complaint with your local data protection authority if you believe your rights have been violated.
          </p>
        </section>

        <section>
          <h2>13. Updates to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices, technologies, legal requirements, or business operations. We will notify you of material changes by:
          </p>
          <ul>
            <li>Posting the updated policy on our website</li>
            <li>Updating the "Last Updated" date at the top of this policy</li>
            <li>Sending email notifications for significant changes</li>
            <li>Displaying prominent notices on our website</li>
          </ul>
          <p>
            Your continued use of our services after such modifications constitutes acceptance of the updated Privacy Policy.
          </p>
        </section>

        <section>
          <h2>14. Contact Information</h2>
          <p>
            If you have questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
          </p>
          
          <div className="contact-details">
            <p><strong>Fitness Health Blog</strong></p>
            <p>Studio 52 Kennedy Grove South Wendy</p>
            <p>London, NW2 2SH</p>
            <p>United Kingdom</p>
            <p>Phone: +448648285526</p>
            <p>Email: privacy@topfitnessproducts.com</p>
            <p>Website: https://topfitnessproducts.com</p>
          </div>

          <p>
            We will respond to your inquiry within 30 days of receipt. For urgent matters, please call our customer service line during business hours.
          </p>
        </section>

        <section>
          <h2>15. Consent</h2>
          <p>
            By using our website and services, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and disclosure of your personal information as described herein.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;